export const TABLE_POLL_MS = 300000;
export const TABLE_ACTION_REFETCH_DELAY_MS = 2000;
export const IDLE_BEFORE_POLL_MS = 5000;

let lastActivityAt: number = typeof window !== 'undefined' ? Date.now() : 0;

if (typeof window !== 'undefined') {
  const onActivity = () => {
    lastActivityAt = Date.now();
  };
  window.addEventListener('mousemove', onActivity, { passive: true });
  window.addEventListener('keydown', onActivity, { passive: true });
  window.addEventListener('click', onActivity, { passive: true });
  window.addEventListener('touchstart', onActivity, { passive: true });
}

export const isUserIdle = (thresholdMs = IDLE_BEFORE_POLL_MS): boolean => Date.now() - lastActivityAt >= thresholdMs;

export const isDropdownOpen = (doc: Document | undefined = typeof document !== 'undefined' ? document : undefined) => {
  if (!doc) return false;

  return Boolean(doc.querySelector('.dropdown-menu.show, .dropdown.show'));
};

export const isModalOpen = (doc: Document | undefined = typeof document !== 'undefined' ? document : undefined) => {
  if (!doc) return false;

  return Boolean(doc.querySelector('.modal.show'));
};

export const isOffcanvasOpen = (doc: Document | undefined = typeof document !== 'undefined' ? document : undefined) => {
  if (!doc) return false;

  return Boolean(doc.querySelector('.offcanvas.show, .phoenix-offcanvas.show'));
};

export const isPollingLockedPanelOpen = (doc: Document | undefined = typeof document !== 'undefined' ? document : undefined) => {
  if (!doc) return false;

  return Boolean(doc.querySelector('[data-polling-lock="true"]'));
};

export const isEditingInput = (doc: Document | undefined = typeof document !== 'undefined' ? document : undefined) => {
  if (!doc) return false;

  const activeElement = doc.activeElement as HTMLElement | null;
  if (!activeElement) return false;

  if (activeElement.isContentEditable) return true;

  return activeElement.matches('input, textarea, select, [role="combobox"]');
};

export const shouldPauseTablePolling = (doc: Document | undefined = typeof document !== 'undefined' ? document : undefined) => {
  return !isUserIdle() || isDropdownOpen(doc) || isModalOpen(doc) || isOffcanvasOpen(doc) || isPollingLockedPanelOpen(doc) || isEditingInput(doc);
};
